import { useIsBehindFeatureFlag } from "./useFeatureFlag";

export const useCanEstimateInventoryAtTimestamp = () => {
  return useIsBehindFeatureFlag("inventory_estimate_at_timestamp");
};
